import Types from './_types';

export namespace Classes {
    export class BootstrapModalWithAjaxContentSettings {
        title: string;
        contentUrl: string;
        saveUrl: string;
        callback: Types.BootstrapModalCallback;
        enableUnobtrusiveValidation: boolean = true;
        infoText: string = '';
        saveText: string = 'Mentés';
        showRejectButton: boolean = true;
        showSaveButton: boolean = true;
        infoIconText: string = '';
        closeModalWindowAfterSave: boolean = true;
        canSaveUsingEnterKey: boolean = true;
        onBeforeSubmit: Function = null;
    }
}

export default Classes;
